import { ModalOverlay, ModalOverlayProps } from '@chakra-ui/react'
import { FC } from 'react'

const CustomModalOverlay: FC<ModalOverlayProps> = (props) => (
  <ModalOverlay bg="rgb(0,0,0,.5)" backdropFilter="blur(4px)" {...props} />
)

export default CustomModalOverlay
